import { NO_KEY, YES_KEY } from '@/common/constants';

export default (value?: boolean) => {
  return value === true ? YES_KEY: value === false ? NO_KEY: '';
};